import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.quiz');
import { OnInit, Input } from "@angular/core";
import { ElementRef, ViewChild } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

const Quiz = [
    {
        type: 'ox',
        question: '드론은 사람이 직접 탑승하여 조종하는 항공 장비이다. (O/X)',
        answer: false,
        response: null,
        commentary: '드론은 원격으로 조종되는 무인 항공 장비로 적외선 카메라 등 다양한 센서를 활용해 정밀한 데이터를 수집하며, 발굴된 유적 상태를 정확하게 기록할 수 있어 문화유산 디지털 보존에 큰 역할을 합니다.'
    },
    {
        type: 'ox',
        question: '디지털 헤리티지란 문화유산을 디지털 기술로 기록하고 활용하는 분야이다. (O/X)',
        answer: true,
        response: null,
        commentary: '디지털 헤리티지는 문화유산을 디지털 기술로 기록하며 보존 및 활용할 수 있도록 하는 분야입니다. 3D 스캔, 확장현실(XR), 인공지능(AI) 등 첨단기술을 통해 유산을 미래세대와 연결합니다.'
    },
    {
        type: 'ox',
        question: '세종특별자치시에는 국립박물관단지가 들어설 예정이다. (O/X)',
        answer: true,
        response: null,
        commentary: '세종특별자치시에는 국립박물관단지가 조성되고 있습니다. 2016년부터 2028년까지 단계적으로 추진되며, 세종시 생활권에 다양한 국립박물관(어린이 박물관, 도시건축 박물관, 디자인박물관, 디지털문화유산센터, 국가기록박물관 등)이 순차적으로 들어설 예정입니다.'
    },
    {
        type: 'ox',
        question: '디지털 헤리티지는 크게 데이터 보존 -> 생산 -> 활용의 순서로 이루어진다. (O/X)',
        answer: false,
        response: null,
        commentary: '디지털 헤리티지는 \'데이터 생산 -> 데이터 보존 -> 데이터 활용\'의 순서로 이루어집니다. 생산 단계에서는 문화유산의 가치를 조사, 발굴, 연구하고 이를 디지털 데이터로 변환하고 보존/관리 단계에서는 이 데이터를 안전하게 보존하고 복원, 시뮬레이션을 통해 유지합니다. 활용 단계에서는 교육, 문화예술, 콘텐츠 제작 등 다양한 방식으로 사회에 환원되고 부가 가치를 창출합니다.'
    },
    {
        type: 'ox',
        question: '진시황릉은 중국 최초의 황제인 진시황의 무덤이다. (O/X)',
        answer: true,
        response: null,
        commentary: '진시황릉은 중국을 최초로 통일한 진시황의 무덤입니다.'
    },
    {
        type: 'ox',
        question: '진시황릉에서 발견된 병마용은 모두 똑같은 생김새를 하고 있다. (O/X)',
        answer: false,
        response: null,
        commentary: '병마용은 실제 군대의 배치와 무장, 복식, 계급 구조를 정교하게 재현한 점토 인형으로, \'천인천면(千人千面)\'이라 불릴 정도로 개별 인물의 생김새가 다르고 매우 사실적입니다.'
    },
    {
        type: 'ox',
        question: '병마용은 진시황릉의 테라코타 군사 조각상으로, 마차와 무기 등이 함께 출토되었다. (O/X)',
        answer: true,
        response: null,
        commentary: '병마용은 진시황릉 동쪽에 위치한 대규모 부장갱으로, 발견된 이래 수천 점의 테라코타 군사 조각상(병마용)과 마차, 무기, 악기 등이 출토되었습니다.'
    },
    {
        type: 'ox',
        question: '기축명아미타불비상은 나무에 새겨진 부처 모형의 불상이다. (O/X)',
        answer: false,
        response: null,
        commentary: '기축명아미타불비상은 나무가 아닌 배처럼 생긴 큰 돌(석재)에 부처의 모습을 새긴 불비상입니다. 앞면에는 아미타불과 극락정토의 모습이, 뒷면에는 발원의 글자가 새겨져 있습니다.'
    },
    {
        type: 'ox',
        question: '기축명아미타불비상은 아미타불이 아닌 석가모니불을 새긴 것이다. (O/X)',
        answer: false,
        response: null,
        commentary: '기축명아미타불비상은 이름에서 알 수 있듯이 아미타불의 모습을 새긴 불비상입니다. 이 불비상은 통일신라시대에 극락정토의 아미타불을 표현한 대표적인 유물로, 앞면에는 아미타불이 설법하는 장면이 새겨져 있습니다.'
    },
    {
        type: 'ox',
        question: '기축명아미타불비상은 통일신라 신문왕 9년(689)에 만들어진 것으로 보인다. (O/X)',
        answer: true,
        response: null,
        commentary: '불비상 뒷면에 새겨진 명문(글씨)에 \'기축년\'이라는 연도는 통일신라시대 신문왕 9년, 서기 689년에 해당합니다.'
    },
    {
        type: 'ox',
        question: '샵티는 고대 이집트인들이 사후 세계에서 일하기 위해 사용한 인형이다. (O/X)',
        answer: true,
        response: null,
        commentary: '고대 이집트 무덤에서 발견되는 작은 미라 형태의 장례용품인 샵티(Shabty)는 이집트어로 \'대답하는 자\'라는 뜻으로 저승에서 죽은 자를 위해 농경과 같은 노동을 대신 수행하도록 만든 조각상입니다.'
    },
    {
        type: 'ox',
        question: '카노푸스 단지는 고대 이집트 미라 장례 과정에서 재물을 보관하는 용도로 사용되었다. (O/X)',
        answer: false,
        response: null,
        commentary: '카노푸스 단지는 고대 이집트 장례의식에서 미라를 만들 때 시신에서 나온 내장(간, 폐, 위, 장 등)을 보관하는 항아리입니다. 각 단지는 호루스의 네 아들 머리 모양 뚜껑으로 구분되며, 내장 보호와 사후세계의 안전한 여행을 기원하는 의미가 있습니다.'
    },
    {
        type: 'ox',
        question: '피라미드는 주로 이집트 왕(파라오)를 위해 지어졌다. (O/X)',
        answer: true,
        response: null,
        commentary: '피라미드는 고대 이집트 문명으로 대표하는 유물로 파라오(왕)의 무덤이자 국가적, 종교적 기념물입니다.'
    },
    {
        type: 'ox',
        question: '샵티는 미라 모형으로 만들어진다. (O/X)',
        answer: true,
        response: null,
        commentary: '샵티는 고대 이집트 무덤에 부장된 미라 모양의 작은 인형상으로, 망자가 사후 세계에서 노동에 소환될 때 대신 응답하여 일하도록 만든 \'장례용 하인\'입니다.'
    },
    {
        type: 'ox',
        question: '다음 중 국가유산산업전 해당 부스에는 고려대학교 문화유산융합학부, 전자및정보공학과와 주식회사 시즌, LITA가 참여했다. (O/X)',
        answer: true,
        response: null,
        commentary: '해당 부스에는 언급된 기관과 기업들이 모두 참여했습니다.'
    },
    {
        type: 'multiple',
        question: '디지털 헤리티지 사이클의 주요 단계는 무엇인가요?',
        options: ['생산, 보존, 활용', '조사, 발굴, 연구', '복원, 보존, 관리', '기록, 전시, 보급'],
        answer: '생산, 보존, 활용',
        response: null,
        commentary: '디지털 헤리티지는 \'데이터 생산 -> 데이터 보존 -> 데이터 활용\'의 단계로 이루어집니다. 생산 단계에서는 문화유산의 가치를 조사, 발굴, 연구하고 이를 디지털 데이터로 변환하고 보존/관리 단계에서는 이 데이터를 안전하게 보존하고 복원, 시뮬레이션을 통해 유지합니다. 활용 단계에서는 교육, 문화예술, 콘텐츠 제작 등 다양한 방식으로 사회에 환원되고 부가 가치를 창출합니다.'
    },
    {
        type: 'multiple',
        question: '광대역 3D 스캐너의 주요 기능은 무엇인가요?',
        options: ['유적의 색상을 복원한다.', '유적의 3차원 형상을 정밀하게 기록한다.', '유적의 소리를 재현한다.', '유적의 냄새를 분석한다.'],
        answer: '유적의 3차원 형상을 정밀하게 기록한다.',
        response: null,
        commentary: '광대역 3D 스캐너는 문화유산의 입체적(3차원) 형상을 정밀하게 측정하고, 기록하는 장치입니다.'
    },
    {
        type: 'multiple',
        question: '드론은 디지털 헤리티지의 어떤 단계에서 주로 사용되나요?',
        options: ['생산 단계', '보존 단계', '활용 단계', '복원 단계'],
        answer: '생산 단계',
        response: null,
        commentary: '드론은 유적지의 항공촬영, 지형 정보 수집 등 현장 조사와 기초데이터 확보에 주로 사용됩니다. 이는 디지털 헤리티지의 ‘생산 단계’에서 이루어지며, 드론이 수집한 데이터는 이후 보존/관리 및 활용의 기초 자료가 됩니다.'
    },
    {
        type: 'multiple',
        question: '디지털 헤리티지의 활용 단계에서 제작되는 콘텐츠는 무엇인가요?',
        options: ['3D 스캐너 데이터', '박물관 실감콘텐츠', '드론 촬영 영상', '도면 제작'],
        answer: '박물관 실감콘텐츠',
        response: null,
        commentary: '활용 단계에서는 디지털화된 문화유산 데이터를 바탕으로 VR/AR 기반의 박물관 체험, 메타버스 투어, 미디어아트 등 다양한 문화예술·교육 콘텐츠가 제작되어 대중에게 제공됩니다.'
    },
    {
        type: 'multiple',
        question: '3D 프린터는 디지털 헤리티지에서 어떤 역할을 하나요?',
        options: ['유적의 색상을 복원한다.', '파손된 유물을 복제하거나 복원한다.', '유적의 소리를 재현한다.', '유적의 냄새를 분석한다.'],
        answer: '파손된 유물을 복제하거나 복원한다.',
        response: null,
        commentary: '3D 프린터는 디지털 스캔 데이터를 이용해 파손된 유물의 복제품을 만들거나, 복원 작업에 활용됩니다. 이를 통해 실제 유물의 보존과 전시, 연구에 큰 도움이 됩니다.'
    },
    {
        type: 'multiple',
        question: '피라미드는 주로 어떤 목적으로 지어졌나요?',
        options: ['시장', '학교', '무덤', '운동장'],
        answer: '무덤',
        response: null,
        commentary: '피라미드는 고대 이집트의 왕(파라오)과 귀족들의 무덤으로 지어진 거대한 석조 건축물입니다. 피라미드 내부에는 왕의 미라와 함께 다양한 부장품이 들어 있었으며, 사후 세계에서의 영생을 기원하는 이집트인의 신앙이 담겨 있습니다.'
    },
    {
        type: 'multiple',
        question: '샵티는 주로 어떤 모양으로 만들어졌나요?',
        options: ['무기', '인형', '음식', '악기'],
        answer: '인형',
        response: null,
        commentary: '고대 이집트 무덤에서 발견되는 작은 미라 형태의 장례용품인 샵티(Shabty)는 이집트어로 \'대답하는 자\'라는 뜻으로 저승에서 죽은 자를 위해 농경과 같은 노동을 대신 수행하도록 만든 조각상이다.'
    },
    {
        type: 'multiple',
        question: '카노푸스 단지는 무엇을 담는 항아리였나요?',
        options: ['물', '음식', '장기', '금화'],
        answer: '장기',
        response: null,
        commentary: '카노푸스 단지는 고대 이집트 장례의식에서 미라를 만들 때 시신에서 나온 내장(간, 폐, 위, 장 등)을 보관하는 항아리입니다. 각 단지는 호루스의 네 아들 머리 모양 뚜껑으로 구분되며, 내장 보호와 사후세계의 안전한 여행을 기원하는 의미가 있습니다.'
    },
    {
        type: 'multiple',
        question: '피라미드가 주로 지어진 곳은 어디의 서쪽 기슭인가요?',
        options: ['아마존강', '나일강', '한강', '황허강'],
        answer: '나일강',
        response: null,
        commentary: '피라미드는 주로 이집트의 나일 강 서쪽 기슭에 세워졌습니다. 고대 이집트인들은 해가 지는 서쪽을 죽음과 사후 세계의 상징으로 여겼기 때문에, 왕의 무덤인 피라미드를 나일 강 서쪽에 건설했습니다.'
    },
    {
        type: 'multiple',
        question: '진시황릉은 어느 나라 황제의 무덤인가요?',
        options: ['일본', '중국', '인도', '이집트'],
        answer: '중국',
        response: null,
        commentary: '중국 섬서성(陝西省) 서안시(西安市) 여산(驪山) 남쪽 기슭에 있는 진시황릉(秦始皇陵)은 중국을 최초로 통일한 진시황(BC 259~BC 210)의 무덤입니다.'
    },
    {
        type: 'multiple',
        question: '진시황릉에서 발견된 흙으로 만든 군사와 말의 모형을 무엇이라 하나요?',
        options: ['병마용', '피라미드', '스핑크스', '모아이 석상'],
        answer: '병마용',
        response: null,
        commentary: '진시황릉에서 출토된 병마용은 현지의 점토인 황토로 제작되어, 가마에서 소성 후 채색을 통해 세밀하게 묘사했으며, 병마용들은 형상이 제각각 다르고 매우 사실적이어서 당시의 의복과 무기, 마구 등이 출토되었습니다.'
    },
    {
        type: 'multiple',
        question: '진시황릉의 병마용은 왜 만들어졌나요?',
        options: ['장식용으로', '사후세계를 지키기 위해', '놀잇감으로', '선물로 주기 위해'],
        answer: '사후세계를 지키기 위해',
        response: null,
        commentary: '진시황릉의 병마용은 진시황이 사후에도 자신의 무덤을 지키고, 저승에서도 살아 있을 때처럼 권력과 군사력을 누릴 수 있도록 제작하였습니다.'
    },
    {
        type: 'multiple',
        question: '기축명아미타불비상은 어떤 재료로 제작되었나요?',
        options: ['나무', '금속', '돌', '유리'],
        answer: '돌',
        response: null,
        commentary: '기축명아미타불비상은 암적갈색의 연질납석(돌)으로 만들어진 불상입니다.'
    },
    {
        type: 'multiple',
        question: '기축명아미타불비상 앞면에는 무엇이 새겨져 있나요?',
        options: ['동물 그림', '부처님 모습', '한글 글씨', '꽃무늬'],
        answer: '부처님 모습',
        response: null,
        commentary: '앞면에는 아미타불을 중심으로 여러 불상과 극락정토의 모습이 새겨져 있습니다.'
    },
    {
        type: 'multiple',
        question: '기축명아미타불비상은 어느 시기에 만들어졌나요?',
        options: ['조선시대', '고려시대', '통일신라시대', '선사시대'],
        answer: '통일신라시대',
        response: null,
        commentary: '뒷면에 새겨진 \'기축년\' 명문을 통해 통일신라 시기 신문왕 9년(689년)에 만들어진 것으로 추정됩니다.'
    }
];

// const Quiz = [
//     // 4지선다형
//     {
//         type: 'multiple',
//         question: '로마의 수도는 어디인가요?',
//         options: ['로마', '파리', '베를린', '마드리드'],
//         answer: '로마',
//         response: null,
//         commentary: '로마는 이탈리아의 수도이자 고대 로마 제국의 중심지입니다.'
//     },
//     {
//         type: 'multiple',
//         question: '백제의 수도는 어디인가요?',
//         options: ['한양', '사비성', '경주', '개경'],
//         answer: '사비성',
//         response: null,
//         commentary: '사비성은 백제의 마지막 수도로, 현재의 부여에 위치해 있습니다.'
//     },
//     {
//         type: 'multiple',
//         question: '이집트의 대표 유물은?',
//         options: ['콜로세움', '앵코르와트', '피라미드', '만리장성'],
//         answer: '피라미드',
//         response: null,
//         commentary: '피라미드는 이집트를 대표하는 고대 유적으로, 파라오의 무덤입니다.'
//     },
//     {
//         type: 'multiple',
//         question: '세계문화유산이 아닌 것은?',
//         options: ['바간', '에펠탑', '앙코르 와트', '진시황릉'],
//         answer: '에펠탑',
//         response: null,
//         commentary: '에펠탑은 프랑스 파리의 상징이지만 세계문화유산으로 지정되어 있지 않습니다.'
//     },

//     // OX 퀴즈
//     {
//         type: 'ox',
//         question: '로마 콜로세움은 검투사 경기장이었다.',
//         answer: true,
//         response: null,
//         commentary: '콜로세움은 고대 로마에서 검투사 경기를 열던 대형 원형 경기장이었습니다.'
//     },
//     {
//         type: 'ox',
//         question: '바간은 한국의 전통 도시이다.',
//         answer: false,
//         response: null,
//         commentary: '바간은 미얀마에 위치한 고대 도시로, 수천 개의 불탑이 있는 유적지입니다.'
//     },
//     {
//         type: 'ox',
//         question: '앙코르 와트는 캄보디아에 있다.',
//         answer: true,
//         response: null,
//         commentary: '앙코르 와트는 캄보디아에 위치한 세계 최대의 힌두교 사원입니다.'
//     },
//     {
//         type: 'ox',
//         question: '진시황릉에는 실제 병사가 묻혀 있다.',
//         answer: false,
//         response: null,
//         commentary: '진시황릉에는 실제 병사가 아닌 테라코타 병마용이 묻혀 있습니다.'
//     }
// ];

@Component({
    selector: 'wiz-portal-kiosk-quiz',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.quiz/view.scss */
/* src/app/portal.kiosk.quiz/view.scss: no such file or directory */`],
})
export class PortalKioskQuizComponent implements OnInit {
    @Input() event: any;
    @Input() opts: any;

    public num: number = 0;
    public quizzes: Quiz[] = Quiz;
    public selectedQuizzes: Quiz[] = [];
    public selectedOptionIndex: number | null = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.selectedQuizzes = this.getShuffledQuizzes();
        await this.service.render();
    }

    public async back() {
        if (this.num == "select") return this.event.view('main');
        this.num = "select";
        await this.service.render();
    }

    public getShuffledQuizzes(): Quiz[] {
        const multipleChoice = this.quizzes.filter(q => q.type === 'multiple');
        const oxChoice = this.quizzes.filter(q => q.type === 'ox');
        const shuffledMultiple = this.shuffle(multipleChoice).slice(0, 3);
        const shuffledOX = this.shuffle(oxChoice).slice(0, 2);
        return [...shuffledMultiple, ...shuffledOX];
    }

    public shuffle<T>(array: T[]): T[] {
        const copied = [...array];
        for (let i = copied.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [copied[i], copied[j]] = [copied[j], copied[i]];
        }
        return copied;
    }

    public async selectOption(value: any) {
        this.selectedQuizzes[this.num].response = value;
        await this.service.render(100);
        await this.service.render(100);
        
        if (this.num + 1 >= this.selectedQuizzes.length) {
            this.event.view("finish");
            this.event.set("quiz", this.selectedQuizzes)
        } else {
            this.num++;
            this.service.render();
        }
    }
}

export default PortalKioskQuizComponent;